import { memo } from 'react'
import { Link } from 'react-router-dom'

const Logo = memo(() => {
  return (
    <Link
      to="/"
      className="flex items-center space-x-3 hover:opacity-80 transition-opacity duration-200"
    >
      <img
        src="/logo.png"
        alt="Wunschparadies Logo"
        className="h-10 w-auto object-contain"
        loading="eager"
        width="40"
        height="40"
      />
    </Link>
  )
})

Logo.displayName = 'Logo'

export default Logo
